/** Dependencies */
import React from 'react';
import { Outlet } from 'react-router-dom';

function CustomerDetails() {
  return <Outlet />;
}

export default CustomerDetails;
